import { createRoot } from 'react-dom/client'
import './index.css'
import { RouterProvider, UNSAFE_DataRouterContext } from 'react-router-dom'
import { router } from './router'

// Enable future flags
const enableFutureFlags = () => {
  // @ts-ignore - These are internal APIs but they're the recommended way to enable future flags
  if (UNSAFE_DataRouterContext._currentValue?.future) {
    // @ts-ignore
    UNSAFE_DataRouterContext._currentValue.future.v7_startTransition = true;
    // @ts-ignore
    UNSAFE_DataRouterContext._currentValue.future.v7_relativeSplatPath = true;
  }
};

enableFutureFlags();

createRoot(document.getElementById('root')!).render(
  <RouterProvider router={router} />
)
